export * from './lib/shared-ui-profile.module'
export * from '../profile/profile.component'
